// extracted by mini-css-extract-plugin
export default {"container":"KcLK1xUAovHzwX_bNBU_","voice-input":"wdpCxgqyTTVOXbMmvvJq","dx-input":"PBjjhXIQrZs_rklOgZvh","icon":"Cs2i8bfKfMgvqQe4ZjVj","button":"lAn4vYQMqu6gvaD_5E1G"};